import React from 'react';
import './index.css';
import { render } from 'react-dom';
import ReactGA from 'react-ga4';
import { App } from './App';
ReactGA.initialize('G-3KLFTRYP8H');
render(<App data-id="element-823" />, document.getElementById('root'));